import { useState } from "react";

import { Dialog, Grid } from "@mui/material";
import { Box } from "@mui/system";

import { useDisclosure } from "hooks";

import { BranchOverview } from "./components/BranchOverview";
import { ManageBranchDetail } from "./components/ManageBranchDetail";

interface Props {
  branchesAndMembers: BranchMembers[];
  viewingAsRoles: Role[];
}
export function BranchManager(props: Props) {
  const { branchesAndMembers, viewingAsRoles } = props;
  const { isOpen, onClose, onOpen } = useDisclosure(false);
  const [selectedBranch, setSelectedBranch] = useState<BranchMembers | null>(
    null,
  );

  if (branchesAndMembers.length === 0 || viewingAsRoles.length === 0) {
    return null;
  }

  const onManageBranchSelected = (branch: BranchMembers) => {
    setSelectedBranch(branch);
    onOpen();
  };

  return (
    <Box mt="1.5rem">
      <Grid container spacing={2} alignItems="stretch">
        {branchesAndMembers.map((branchMembers) => (
          <Grid item xs={12} sm={6} md={4} lg={3} key={branchMembers.branch.id}>
            <BranchOverview
              branchMembers={branchMembers}
              onManageBranch={onManageBranchSelected}
            />
          </Grid>
        ))}
      </Grid>
      <Dialog
        open={isOpen && selectedBranch !== null}
        onClose={onClose}
        PaperProps={{
          sx: {
            width: "70vw", // 50% of the viewport width
            height: "70vh", // 50% of the viewport height
            maxWidth: "none", // Ensures it doesn't shrink based on default max-width
            overflowY: "scroll",
          },
        }}
      >
        <Box p="1.5rem">
          {selectedBranch != null && (
            <ManageBranchDetail
              branchMembers={selectedBranch}
              viewingAsRoles={viewingAsRoles}
            />
          )}
        </Box>
      </Dialog>
    </Box>
  );
}
